import styled from 'styled-components';
import { config } from '../../../../../../../components/dashboards/config';

export const ActionsColumnStyle = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  color: var(--mmt-primary-70);
  cursor: pointer;

  p {
    margin: 0px;
    margin-left: 4px;
  }

  svg {
    margin-top: 4px;
  }

  &.recs-eye {
    svg {
      font-size: var(--font-size-lg);
      margin-top: -4px;
    }
  }

  &.dashed {
    div {
      border: 1px dashed var(--mmt-primary-70);
      padding-left: 4px;
      padding-right: 4px;

      svg {
        padding: 0px;
        margin: 0px;
        margin-top: -4px;
      }
    }
  }
`;

export default styled.div`
  width: -webkit-fill-available;
  height: 100%;
  padding: 0px ${config.PADDING}px ${config.PADDING}px ${config.PADDING}px;
  display: flex;
  position: relative;
  overflow: hidden;
  flex-direction: column;

  .ant-table-wrapper {
    display: flex;
    flex-direction: column;
    
    .ant-spin-nested-loading {
      flex: 1;
      display: flex;
      flex-direction: column;

      .ant-spin-container {
        flex: 1;
        display: flex;
        flex-direction: column;

        .ant-table {
          flex: 1;
        }
      }
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .ant-table-placeholder {
    display: none;
  }

  .status-tag {
    width: 80px;
    text-align: center;
  }

  .objective-tag {
    overflow: hidden;
  }

  .ant-table {
    tr.ant-table-row-level-0:hover > td {
      background: unset;
    }
  }

  &.no-data {
    min-height: 442px;
  }
`;
